import { TipoArquivo } from "@workflow/types";

import { FileTypeConfig } from "./types";

/**
 * Mapa de cores por tipo de arquivo. Cada entrada define borda, fundo, texto e
 * ícones nos estados normal/ativo, para os modos `default` (dropzone) e `lite`.
 */
export const fileTypeConfig: Record<TipoArquivo, FileTypeConfig> = {
  COMPRAS: {
    // Roxo (Financeiro/Compras)
    border: "border-purple-200/60 dark:border-purple-500/30",
    activeBorder: "border-purple-500 dark:border-purple-400",
    bg: "bg-purple-50/50 dark:bg-purple-500/5",
    activeBg: "bg-purple-50 dark:bg-purple-500/10",
    text: "text-purple-700 dark:text-purple-300",
    button:
      "text-purple-700 border-purple-200 hover:bg-purple-50 hover:text-purple-900 dark:text-purple-300 dark:border-purple-800 dark:hover:bg-purple-500/20 dark:hover:text-purple-100",
    icon: "text-purple-400 dark:text-purple-400",
    fileIcon: "text-purple-600 dark:text-purple-400",
    liteBg: "bg-purple-50 hover:bg-purple-100/50 dark:bg-purple-500/10 dark:hover:bg-purple-500/20",
  },
  INTERNO: {
    // Azul (Corporativo/Padrão)
    border: "border-blue-200/60 dark:border-blue-500/30",
    activeBorder: "border-blue-500 dark:border-blue-400",
    bg: "bg-blue-50/50 dark:bg-blue-500/5",
    activeBg: "bg-blue-50 dark:bg-blue-500/10",
    text: "text-blue-700 dark:text-blue-300",
    button:
      "text-blue-700 border-blue-200 hover:bg-blue-50 hover:text-blue-900 dark:text-blue-300 dark:border-blue-800 dark:hover:bg-blue-500/20 dark:hover:text-blue-100",
    icon: "text-blue-400 dark:text-blue-400",
    fileIcon: "text-blue-600 dark:text-blue-400",
    liteBg: "bg-blue-50 hover:bg-blue-100/50 dark:bg-blue-500/10 dark:hover:bg-blue-500/20",
  },
  COMERCIAL: {
    // Laranja (Vendas/Cliente)
    border: "border-orange-200/60 dark:border-orange-500/30",
    activeBorder: "border-orange-500 dark:border-orange-400",
    bg: "bg-orange-50/50 dark:bg-orange-500/5",
    activeBg: "bg-orange-50 dark:bg-orange-500/10",
    text: "text-orange-700 dark:text-orange-300",
    button:
      "text-orange-700 border-orange-200 hover:bg-orange-50 hover:text-orange-900 dark:text-orange-300 dark:border-orange-800 dark:hover:bg-orange-500/20 dark:hover:text-orange-100",
    icon: "text-orange-400 dark:text-orange-400",
    fileIcon: "text-orange-600 dark:text-orange-400",
    liteBg: "bg-orange-50 hover:bg-orange-100/50 dark:bg-orange-500/10 dark:hover:bg-orange-500/20",
  },
  APROVACAO: {
    // Indigo (Formalidade)
    border: "border-indigo-200/60 dark:border-indigo-500/30",
    activeBorder: "border-indigo-500 dark:border-indigo-400",
    bg: "bg-indigo-50/50 dark:bg-indigo-500/5",
    activeBg: "bg-indigo-50 dark:bg-indigo-500/10",
    text: "text-indigo-700 dark:text-indigo-300",
    button:
      "text-indigo-700 border-indigo-200 hover:bg-indigo-50 hover:text-indigo-900 dark:text-indigo-300 dark:border-indigo-800 dark:hover:bg-indigo-500/20 dark:hover:text-indigo-100",
    icon: "text-indigo-400 dark:text-indigo-400",
    fileIcon: "text-indigo-600 dark:text-indigo-400",
    liteBg: "bg-indigo-50 hover:bg-indigo-100/50 dark:bg-indigo-500/10 dark:hover:bg-indigo-500/20",
  },
  AP: {
    // Emerald (Sucesso/Segurança)
    border: "border-emerald-200/60 dark:border-emerald-500/30",
    activeBorder: "border-emerald-500 dark:border-emerald-400",
    bg: "bg-emerald-50/50 dark:bg-emerald-500/5",
    activeBg: "bg-emerald-50 dark:bg-emerald-500/10",
    text: "text-emerald-700 dark:text-emerald-300",
    button:
      "text-emerald-700 border-emerald-200 hover:bg-emerald-50 hover:text-emerald-900 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-emerald-500/20 dark:hover:text-emerald-100",
    icon: "text-emerald-400 dark:text-emerald-400",
    fileIcon: "text-emerald-600 dark:text-emerald-400",
    liteBg:
      "bg-emerald-50 hover:bg-emerald-100/50 dark:bg-emerald-500/10 dark:hover:bg-emerald-500/20",
  },
  JOB_BRIEFING: {
    // Amber (Atenção/Briefing)
    border: "border-amber-200/60 dark:border-amber-500/30",
    activeBorder: "border-amber-500 dark:border-amber-400",
    bg: "bg-amber-50/50 dark:bg-amber-500/5",
    activeBg: "bg-amber-50 dark:bg-amber-500/10",
    text: "text-amber-700 dark:text-amber-300",
    button:
      "text-amber-700 border-amber-200 hover:bg-amber-50 hover:text-amber-900 dark:text-amber-300 dark:border-amber-800 dark:hover:bg-amber-500/20 dark:hover:text-amber-100",
    icon: "text-amber-400 dark:text-amber-400",
    fileIcon: "text-amber-600 dark:text-amber-400",
    liteBg: "bg-amber-50 hover:bg-amber-100/50 dark:bg-amber-500/10 dark:hover:bg-amber-500/20",
  },
  JOB_PAPER: {
    border: "border-rose-200/60 dark:border-rose-500/30",
    activeBorder: "border-rose-500 dark:border-rose-400",
    bg: "bg-rose-50/50 dark:bg-rose-500/5",
    activeBg: "bg-rose-50 dark:bg-rose-500/10",
    text: "text-rose-700 dark:text-rose-300",
    button:
      "text-rose-700 border-rose-200 hover:bg-rose-50 hover:text-rose-900 dark:text-rose-300 dark:border-rose-800 dark:hover:bg-rose-500/20 dark:hover:text-rose-100",
    icon: "text-rose-400 dark:text-rose-400",
    fileIcon: "text-rose-600 dark:text-rose-400",
    liteBg: "bg-rose-50 hover:bg-rose-100/50 dark:bg-rose-500/10 dark:hover:bg-rose-500/20",
  },
  JOB_ESTUDO_VERBA: {
    // Teal (Documento de entrega do job)
    border: "border-teal-200/60 dark:border-teal-500/30",
    activeBorder: "border-teal-500 dark:border-teal-400",
    bg: "bg-teal-50/50 dark:bg-teal-500/5",
    activeBg: "bg-teal-50 dark:bg-teal-500/10",
    text: "text-teal-700 dark:text-teal-300",
    button:
      "text-teal-700 border-teal-200 hover:bg-teal-50 hover:text-teal-900 dark:text-teal-300 dark:border-teal-800 dark:hover:bg-teal-500/20 dark:hover:text-teal-100",
    icon: "text-teal-400 dark:text-teal-400",
    fileIcon: "text-teal-600 dark:text-teal-400",
    liteBg: "bg-teal-50 hover:bg-teal-100/50 dark:bg-teal-500/10 dark:hover:bg-teal-500/20",
  },
  JOB_PROJETO_EXECUTIVO: {
    // Slate (documento técnico de execução)
    border: "border-slate-200/60 dark:border-slate-500/30",
    activeBorder: "border-slate-500 dark:border-slate-400",
    bg: "bg-slate-50/50 dark:bg-slate-500/5",
    activeBg: "bg-slate-50 dark:bg-slate-500/10",
    text: "text-slate-700 dark:text-slate-300",
    button:
      "text-slate-700 border-slate-200 hover:bg-slate-50 hover:text-slate-900 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-500/20 dark:hover:text-slate-100",
    icon: "text-slate-400 dark:text-slate-400",
    fileIcon: "text-slate-600 dark:text-slate-400",
    liteBg: "bg-slate-50 hover:bg-slate-100/50 dark:bg-slate-500/10 dark:hover:bg-slate-500/20",
  },
  JOB_PROJETO_FINAL: {
    // Cyan (documento final de entrega)
    border: "border-cyan-200/60 dark:border-cyan-500/30",
    activeBorder: "border-cyan-500 dark:border-cyan-400",
    bg: "bg-cyan-50/50 dark:bg-cyan-500/5",
    activeBg: "bg-cyan-50 dark:bg-cyan-500/10",
    text: "text-cyan-700 dark:text-cyan-300",
    button:
      "text-cyan-700 border-cyan-200 hover:bg-cyan-50 hover:text-cyan-900 dark:text-cyan-300 dark:border-cyan-800 dark:hover:bg-cyan-500/20 dark:hover:text-cyan-100",
    icon: "text-cyan-400 dark:text-cyan-400",
    fileIcon: "text-cyan-600 dark:text-cyan-400",
    liteBg: "bg-cyan-50 hover:bg-cyan-100/50 dark:bg-cyan-500/10 dark:hover:bg-cyan-500/20",
  },
  PO: {
    // Pink (Documento Específico)
    border: "border-pink-200/60 dark:border-pink-500/30",
    activeBorder: "border-pink-500 dark:border-pink-400",
    bg: "bg-pink-50/50 dark:bg-pink-500/5",
    activeBg: "bg-pink-50 dark:bg-pink-500/10",
    text: "text-pink-700 dark:text-pink-300",
    button:
      "text-pink-700 border-pink-200 hover:bg-pink-50 hover:text-pink-900 dark:text-pink-300 dark:border-pink-800 dark:hover:bg-pink-500/20 dark:hover:text-pink-100",
    icon: "text-pink-400 dark:text-pink-400",
    fileIcon: "text-pink-600 dark:text-pink-400",
    liteBg: "bg-pink-50 hover:bg-pink-100/50 dark:bg-pink-500/10 dark:hover:bg-pink-500/20",
  },
  NF: {
    // Rose (Fiscal/Importante)
    border: "border-rose-200/60 dark:border-rose-500/30",
    activeBorder: "border-rose-500 dark:border-rose-400",
    bg: "bg-rose-50/50 dark:bg-rose-500/5",
    activeBg: "bg-rose-50 dark:bg-rose-500/10",
    text: "text-rose-700 dark:text-rose-300",
    button:
      "text-rose-700 border-rose-200 hover:bg-rose-50 hover:text-rose-900 dark:text-rose-300 dark:border-rose-800 dark:hover:bg-rose-500/20 dark:hover:text-rose-100",
    icon: "text-rose-400 dark:text-rose-400",
    fileIcon: "text-rose-600 dark:text-rose-400",
    liteBg: "bg-rose-50 hover:bg-rose-100/50 dark:bg-rose-500/10 dark:hover:bg-rose-500/20",
    label: "Nota Fiscal",
  },
  COMPROVANTE_ENTREGA_FATURAMENTO: {
    // Fuchsia (Variação do Pink para diferenciar)
    border: "border-fuchsia-200/60 dark:border-fuchsia-500/30",
    activeBorder: "border-fuchsia-500 dark:border-fuchsia-400",
    bg: "bg-fuchsia-50/50 dark:bg-fuchsia-500/5",
    activeBg: "bg-fuchsia-50 dark:bg-fuchsia-500/10",
    text: "text-fuchsia-700 dark:text-fuchsia-300",
    button:
      "text-fuchsia-700 border-fuchsia-200 hover:bg-fuchsia-50 hover:text-fuchsia-900 dark:text-fuchsia-300 dark:border-fuchsia-800 dark:hover:bg-fuchsia-500/20 dark:hover:text-fuchsia-100",
    icon: "text-fuchsia-400 dark:text-fuchsia-400",
    fileIcon: "text-fuchsia-600 dark:text-fuchsia-400",
    liteBg:
      "bg-fuchsia-50 hover:bg-fuchsia-100/50 dark:bg-fuchsia-500/10 dark:hover:bg-fuchsia-500/20",
    label: "Comprovante de Entrega de Faturamento",
  },
  EVIDENCIA_BRINDE: {
    // Fuchsia (Variação do Pink para diferenciar)
    border: "border-fuchsia-200/60 dark:border-fuchsia-500/30",
    activeBorder: "border-fuchsia-500 dark:border-fuchsia-400",
    bg: "bg-fuchsia-50/50 dark:bg-fuchsia-500/5",
    activeBg: "bg-fuchsia-50 dark:bg-fuchsia-500/10",
    text: "text-fuchsia-700 dark:text-fuchsia-300",
    button:
      "text-fuchsia-700 border-fuchsia-200 hover:bg-fuchsia-50 hover:text-fuchsia-900 dark:text-fuchsia-300 dark:border-fuchsia-800 dark:hover:bg-fuchsia-500/20 dark:hover:text-fuchsia-100",
    icon: "text-fuchsia-400 dark:text-fuchsia-400",
    fileIcon: "text-fuchsia-600 dark:text-fuchsia-400",
    liteBg:
      "bg-fuchsia-50 hover:bg-fuchsia-100/50 dark:bg-fuchsia-500/10 dark:hover:bg-fuchsia-500/20",
    label: "Comprovante de Entrega de Faturamento",
  },
  JOB_PLANEJAMENTO_APRESENTACAO: {
    // Teal (Apresentação)
    border: "border-teal-200/60 dark:border-teal-500/30",
    activeBorder: "border-teal-500 dark:border-teal-400",
    bg: "bg-teal-50/50 dark:bg-teal-500/5",
    activeBg: "bg-teal-50 dark:bg-teal-500/10",
    text: "text-teal-700 dark:text-teal-300",
    button:
      "text-teal-700 border-teal-200 hover:bg-teal-50 hover:text-teal-900 dark:text-teal-300 dark:border-teal-800 dark:hover:bg-teal-500/20 dark:hover:text-teal-100",
    icon: "text-teal-400 dark:text-teal-400",
    fileIcon: "text-teal-600 dark:text-teal-400",
    liteBg: "bg-teal-50 hover:bg-teal-100/50 dark:bg-teal-500/10 dark:hover:bg-teal-500/20",
    label: "Apresentação do Job",
  },
  TAREFA: {
    // Teal (Tarefa)
    border: "border-teal-200/60 dark:border-teal-500/30",
    activeBorder: "border-teal-500 dark:border-teal-400",
    bg: "bg-teal-50/50 dark:bg-teal-500/5",
    activeBg: "bg-teal-50 dark:bg-teal-500/10",
    text: "text-teal-700 dark:text-teal-300",
    button:
      "text-teal-700 border-teal-200 hover:bg-teal-50 hover:text-teal-900 dark:text-teal-300 dark:border-teal-800 dark:hover:bg-teal-500/20 dark:hover:text-teal-100",
    icon: "text-teal-400 dark:text-teal-400",
    fileIcon: "text-teal-600 dark:text-teal-400",
    liteBg: "bg-teal-50 hover:bg-teal-100/50 dark:bg-teal-500/10 dark:hover:bg-teal-500/20",
    label: "Apresentação do Job",
  },
};
